import { CodeXml } from "lucide-react";
import { Link } from "react-router-dom";
import { usePublicConfig } from "../lib/publicConfig";

export function Footer() {
    const cfg = usePublicConfig();
    const year = new Date().getFullYear();
    return (
        <footer className="mt-12 border-t border-pugio-border bg-white px-4 py-5 text-xs text-pugio-muted sm:px-6">
            <div className="mx-auto flex max-w-7xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <span>© {year} Pugio</span>
                <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
                    <Link to="/pricing" className="hover:text-pugio-text">Pricing</Link>
                    <a href={`mailto:${cfg.support_email}?subject=Pugio%20support%20request`} className="hover:text-pugio-text">Support</a>
                    <Link to="/docs/quickstart" className="hover:text-pugio-text">Docs</Link>
                    {cfg.status_page_url && (
                        <a href={cfg.status_page_url} target="_blank" rel="noreferrer" className="hover:text-pugio-text">Status</a>
                    )}
                    <a href="https://github.com/CallMeJones/pugio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 hover:text-pugio-text">
                        <CodeXml size={14} aria-hidden="true" />
                        GitHub
                    </a>
                </div>
            </div>
        </footer>
    );
}
